import { Button, CircularProgress } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { showErrorAction } from 'containers/Notification/actions';
import {
  GooderaBookOpportunityPayload,
  OpportunityProvider,
  OpportunityType,
  useImportOpportunityMutation,
} from 'generated/graphql';

import { Opportunity } from '../types';

import { BookGooderaOpportunityModal } from './BookGooderaOpportunityModal';

export const ImportOpportunityButton = ({ opportunity }: { opportunity: Opportunity }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [importOpportunity, { loading: isImporting }] = useImportOpportunityMutation({
    onError: () => {
      dispatch(showErrorAction('An error occurred, please try again.'));
    },
  });
  const [eventBookingCommenced, setEventBookingCommenced] = useState(false);

  const isGoodera = opportunity.provider === OpportunityProvider.Goodera;

  const importOpportunityHandler = async (
    gooderaBookOpportunityPayload?: GooderaBookOpportunityPayload
  ) => {
    const importResult = await importOpportunity({
      variables: {
        provider: opportunity.provider,
        providerId: opportunity.providerId,
        gooderaBookOpportunityPayload,
      },
    });
    const importedOpportunityId = importResult.data?.importOpportunity?.id;
    if (importedOpportunityId) {
      history.push(
        `/deeds/${
          opportunity.type === OpportunityType.Project ? 'projects' : 'volunteer'
        }/edit/${importedOpportunityId}`
      );
    }
  };
  return (
    <>
      <Button
        color="primary"
        variant="contained"
        disabled={isImporting}
        onClick={() => {
          if (isGoodera) {
            setEventBookingCommenced(true);
          } else {
            void importOpportunityHandler();
          }
        }}
        style={{ margin: '0 0 8px 8px' }}
      >
        {isImporting ? <CircularProgress size={20} /> : <>{isGoodera ? 'Book' : 'Add'}</>}
      </Button>
      {eventBookingCommenced && (
        <BookGooderaOpportunityModal
          opportunity={opportunity}
          onClose={() => setEventBookingCommenced(false)}
          importOpportunity={importOpportunityHandler}
        />
      )}
    </>
  );
};
